<template>
  <section class="social-feed-modern">
    <div class="tsj-container">
      
      <div class="social-app-header">
        <div class="user-info">
          <div class="avatar-story">
            <img src="@/assets/perfil.jpeg" alt="Jesús Cavazos">
          </div>
          <div class="user-text">
            <span class="username">jesuscavzs</span>
            <span class="status"><span class="live-dot"></span> Recomendado</span>
          </div>
        </div>
        <a href="https://www.tiktok.com/@jesuscavzs" target="_blank" class="follow-btn">Ver Perfil</a>
      </div>

      <div class="title-wrapper">
        <h2 class="social-main-title">El Estilo de <span>Jesús Cavazos</span></h2>
        <p class="social-subtitle">Haz clic para ver el outfit en movimiento</p>
      </div>

      <div class="reels-container">
        <div 
          v-for="(video, index) in videoList" 
          :key="index" 
          class="reel-card"
          @click="openVideo(index)"
        >
          <div class="reel-video-wrapper">
            <video 
              :src="video.url + '#t=0.001'" 
              preload="metadata" 
              muted 
              playsinline 
              class="reel-preview"
            ></video>
            <div class="reel-info-overlay">
              <div class="reel-badge" v-if="video.tag">{{ video.tag }}</div>
              <div class="reel-footer">
                <div class="reel-stats"><i class="fas fa-play"></i> {{ video.views }}</div>
                <div class="reel-action">Ver productos</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Transition name="reel-zoom">
      <div v-if="activeVideo !== null" class="video-overlay" @click.self="closeVideo">
        <button class="close-btn-mobile" @click="closeVideo">✕</button>
        
        <div class="video-player-wrapper">
          <video 
            ref="videoPlayer"
            :src="videoList[activeVideo].url" 
            autoplay 
            loop 
            playsinline
            class="full-video"
          ></video>
          
          <div class="mobile-shoppable-container">
            <p class="multi-title-simple">
              {{ videoList[activeVideo].products.length > 1 ? '🔥 COMPLETA TU OUTFIT' : '🔥 LLEVA EL ESTILO' }}
            </p>
            
            <div class="products-slider-mobile" ref="prodSlider">
              <div 
                v-for="(prod, pIdx) in videoList[activeVideo].products" 
                :key="pIdx"
                class="mini-shop-card-mobile"
              >
                <div class="card-inner-mobile bounce-item">
                  <div class="image-container">
                    <img :src="prod.image" :alt="prod.name">
                  </div>
                  <div class="mini-content-mobile">
                    <h4>{{ prod.name }}</h4>
                    <button @click.stop="goToProduct(prod.handle)" class="btn-buy-now btn-jump">
                      ¡LO QUIERO! <i class="fas fa-shopping-cart"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </section>
</template>

<script>
export default {
  name: 'VideoSocialFeed',
  data() {
    return {
      activeVideo: null,
      autoScrollInterval: null,
      videoList: [
        {
          url: require('@/assets/1.mp4').default || require('@/assets/1.mp4'),
          views: "4.5M",
          tag: "TENDENCIA",
          products: [
            {
              name: "Gorra San Judas 'El Patron'",
              image: require('@/assets/IMG_1804.jpg').default || require('@/assets/IMG_1804.jpg'),
              handle: "gorra-san-judas-el-patron"
            },
            {
              name: "Escapulario San Judas",
              image: require('@/assets/2.png').default || require('@/assets/2.png'),
              handle: "escapulario-san-judas"
            }
          ]
        },
        {
          url: require('@/assets/01.mp4').default || require('@/assets/01.mp4'),
          views: "12.1K",
          tag: "MÁS VENDIDO",
          products: [
            {
              name: "Gorra San Judas 'El Patron'",
              image: require('@/assets/IMG_1804.jpg').default || require('@/assets/IMG_1804.jpg'),
              handle: "gorra-san-judas-el-patron"
            },
            {
              name: "Escapulario Duo",
              image: require('@/assets/esca.jpeg').default || require('@/assets/esca.jpeg'),
              handle: "escapulario-de-tela-virgen-san-judas"
            }
          ]
        },
        {
          url: require('@/assets/002.mp4').default || require('@/assets/002.mp4'),
          views: "25.9K",
          tag: "EXCLUSIVO",
          products: [
            {
              name: "Gorra San Judas 'El Patron'",
              image: require('@/assets/IMG_1804.jpg').default || require('@/assets/IMG_1804.jpg'),
              handle: "gorra-san-judas-el-patron"
            },
             {
              name: "Escapulario San Judas",
              image: require('@/assets/2.png').default || require('@/assets/2.png'),
              handle: "escapulario-san-judas"
            }
          ]
        }
      ]
    };
  },
  methods: {
    openVideo(index) {
      this.activeVideo = index;
      document.body.style.overflow = 'hidden';
      this.$nextTick(() => {
        this.startAutoScroll();
      });
    },
    closeVideo() {
      if (this.$refs.videoPlayer) this.$refs.videoPlayer.pause();
      this.stopAutoScroll();
      this.activeVideo = null;
      document.body.style.overflow = '';
    },
    startAutoScroll() {
      const slider = this.$refs.prodSlider;
      if (!slider || !this.videoList[this.activeVideo] || this.videoList[this.activeVideo].products.length <= 1) return;

      this.autoScrollInterval = setInterval(() => {
        const maxScroll = slider.scrollWidth - slider.clientWidth;
        if (slider.scrollLeft >= maxScroll - 10) {
          slider.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          slider.scrollBy({ left: slider.clientWidth * 0.9, behavior: 'smooth' });
        }
      }, 3500);
    },
    stopAutoScroll() {
      if (this.autoScrollInterval) clearInterval(this.autoScrollInterval);
    },
    goToProduct(handle) {
      this.closeVideo();
      const cleanHandle = handle.replace(/'/g, "").trim();
      this.$nextTick(() => {
        this.$router.push(`/producto/${cleanHandle}`).catch(() => {
          this.$router.push({ name: "ProductPage", params: { handle: cleanHandle } });
        });
      });
    }
  },
  beforeUnmount() {
    this.stopAutoScroll();
  }
};
</script>

<style scoped>
/* ESTILOS BASE */
.social-feed-modern { padding: 40px 0; background: #fff; font-family: 'Montserrat', sans-serif; overflow: hidden; }
.tsj-container { max-width: 1200px; margin: 0 auto; padding: 0 20px; }

.social-app-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.avatar-story { width: 70px; height: 70px; background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888); border-radius: 50%; padding: 2px; }
.avatar-story img { width: 100%; height: 100%; border-radius: 50%; border: 2px solid #fff; object-fit: cover; }
.username { font-weight: 800; font-size: 1rem; color: #1a1a1a; }
.status { font-size: 0.7rem; color: #666; display: flex; align-items: center; gap: 4px; }
.live-dot { width: 7px; height: 7px; background: #ff0050; border-radius: 50%; animation: pulse 1.5s infinite; }
.follow-btn { background: #1a1a1a; color: #fff; padding: 8px 16px; border-radius: 20px; font-size: 0.8rem; font-weight: 800; text-decoration: none; }

.social-main-title { font-size: 1.6rem; font-weight: 300; }
.social-main-title span { font-weight: 900; color: #d9c5b2; text-transform: uppercase; }
.social-subtitle { color: #888; font-size: 0.85rem; margin-top: 4px; }

.reels-container { display: flex; gap: 12px; overflow-x: auto; padding: 10px 0 20px; scrollbar-width: none; -webkit-overflow-scrolling: touch; }
.reels-container::-webkit-scrollbar { display: none; }

.reel-card { flex: 0 0 160px; cursor: pointer; }
.reel-video-wrapper { position: relative; width: 100%; aspect-ratio: 9/16; border-radius: 15px; overflow: hidden; background: #000; }
.reel-preview { width: 100%; height: 100%; object-fit: cover; opacity: 1; background: #000; }
.reel-info-overlay { position: absolute; inset: 0; padding: 10px; display: flex; flex-direction: column; justify-content: space-between; background: linear-gradient(to bottom, transparent 50%, rgba(0,0,0,0.7) 100%); }
.reel-badge { background: #d9c5b2; color: #000; padding: 3px 8px; border-radius: 4px; font-size: 0.55rem; font-weight: 900; align-self: flex-start; }
.reel-footer { display: flex; justify-content: space-between; align-items: center; color: #fff; font-size: 0.65rem; font-weight: 700; }

/* OVERLAY FULLSCREEN */
.video-overlay { 
  position: fixed; 
  top: 0; left: 0; 
  width: 100%; height: 100%; 
  background: #000; 
  z-index: 100000; 
  display: flex; 
  align-items: center; 
  justify-content: center;
}

.video-player-wrapper { position: relative; width: 100%; height: 100%; background: #000; }
.full-video { width: 100%; height: 100%; object-fit: cover; }

.close-btn-mobile {
  position: absolute;
  top: 50px;
  right: 20px;
  background: rgba(0,0,0,0.6);
  border: 1px solid rgba(255,255,255,0.4);
  color: white;
  width: 40px; height: 40px;
  border-radius: 50%;
  font-size: 1.2rem;
  z-index: 100002;
  cursor: pointer;
  display: flex; align-items: center; justify-content: center;
}

.mobile-shoppable-container {
  position: absolute;
  bottom: 35px;
  left: 0;
  width: 100%;
  padding: 0 12px;
  z-index: 100001;
}

.multi-title-simple {
  color: #fff;
  font-size: 0.8rem;
  font-weight: 900;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 12px;
  letter-spacing: 1px;
  text-shadow: 0 2px 8px rgba(0,0,0,0.9);
}

.products-slider-mobile { 
  display: flex; 
  gap: 15px; 
  overflow-x: auto; 
  scrollbar-width: none; 
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  padding: 10px 0;
}
.products-slider-mobile::-webkit-scrollbar { display: none; }

.mini-shop-card-mobile { flex: 0 0 92%; scroll-snap-align: center; }

/* --- DISEÑO DE TARJETA GRANDE Y CON SALTO --- */
.card-inner-mobile {
  background: #fff;
  padding: 15px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow: 0 15px 35px rgba(0,0,0,0.6);
  border: 2px solid #d9c5b2; /* Borde dorado para resaltar */
}

/* Animación de entrada con salto */
.animate-slide-up .bounce-item {
  animation: cardJump 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes cardJump {
  0% { transform: translateY(50px) scale(0.8); opacity: 0; }
  100% { transform: translateY(0) scale(1); opacity: 1; }
}

.image-container {
  width: 80px;
  height: 80px;
  flex-shrink: 0;
}

.card-inner-mobile img { 
  width: 100%; 
  height: 100%; 
  border-radius: 14px; 
  object-fit: cover; 
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.mini-content-mobile { flex: 1; }

.mini-content-mobile h4 { 
  font-size: 0.95rem; 
  font-weight: 900; 
  margin: 0 0 8px 0; 
  color: #1a1a1a; 
  text-transform: uppercase;
  line-height: 1.1;
}

.btn-buy-now { 
  background: #1a1a1a; 
  color: #fff; 
  border: none; 
  padding: 12px; 
  border-radius: 12px; 
  font-size: 0.8rem; 
  font-weight: 900; 
  width: 100%; 
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: transform 0.2s;
}

/* Botón saltarín constante para llamar la atención */
.btn-jump {
  animation: heartBeat 2s infinite;
}

@keyframes heartBeat {
  0% { transform: scale(1); }
  5% { transform: scale(1.05); }
  10% { transform: scale(1); }
  15% { transform: scale(1.1); }
  30% { transform: scale(1); }
  100% { transform: scale(1); }
}

@media (min-width: 1024px) {
  .reels-container { display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px; }
  .reel-card { flex: none; width: 100%; }
  .video-player-wrapper { height: 90vh; aspect-ratio: 9/16; border-radius: 20px; overflow: hidden; }
  .mini-shop-card-mobile { flex: 0 0 350px; }
  .mobile-shoppable-container { width: 450px; left: 50%; transform: translateX(-50%); }
}

@keyframes pulse { 0% { transform: scale(1); } 50% { transform: scale(1.15); } 100% { transform: scale(1); } }

.reel-zoom-enter-active, .reel-zoom-leave-active { transition: all 0.4s ease; }
.reel-zoom-enter-from { opacity: 0; transform: scale(0.9); }
</style>